module.exports = __webpack_public_path__ + "img/classify2-active.95e5899.png";